import {Link} from 'react-router-dom'

export function ForgotPassword() {
  return (
    <div className='w-100'>
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>Forgot Password ?</h1>
        {/* end::Title */}
      </div>

      {/* begin::Message */}
      <div className='mb-10 bg-light-primary p-8 rounded-3 border border-primary border-dashed'>
        <div className='d-flex align-items-start'>
          <div className='symbol symbol-50px me-4'>
            <div className='symbol-label bg-primary'>
              <i className='ki-duotone ki-security-user fs-2x text-white'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </div>
          </div>
          <div className='flex-grow-1'>
            <h4 className='text-primary fw-bold mb-3'>Password Reset Request</h4>
            <div className='text-gray-700 fw-semibold fs-6 mb-3'>
              For security reasons, password resets must be handled by your system administrator.
            </div>
            <div className='text-gray-700 fw-semibold fs-6'>
              Please contact your administrator and provide them with your username to request a password reset.
            </div>
          </div>
        </div>
      </div>
      {/* end::Message */}

      {/* begin::Additional Info */}
      <div className='mb-10 bg-light-warning p-6 rounded'>
        <div className='d-flex align-items-center'>
          <i className='ki-duotone ki-information-5 fs-2x text-warning me-3'>
            <span className='path1'></span>
            <span className='path2'></span>
            <span className='path3'></span>
          </i>
          <div className='text-gray-700 fw-semibold fs-7'>
            Your administrator will verify your identity and reset your password securely.
          </div>
        </div>
      </div>
      {/* end::Additional Info */}

      {/* begin::Actions */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <Link to='/auth/login'>
          <button
            type='button'
            className='btn btn-primary'
          >
            Back to Login
          </button>
        </Link>
      </div>
      {/* end::Actions */}
    </div>
  )
}
